import React from 'react';
import CustomMarkdown from './CustomMarkdown/CustomMarkdown';
import styles from './userMessage.module.scss';
import { Message } from '@/modules/chat/types/message';

type Props = {
  message: Message;
  primaryColor?: string;
  secondaryColor?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const UserMessage = ({ message, primaryColor, secondaryColor, ...props }: Props): React.ReactElement => {
  const messageStyle = primaryColor ? { '--primary-color': primaryColor, '--secondary-color': secondaryColor } as React.CSSProperties : undefined;

  return (
    <div className={styles['user-message-container']}>
      <div className={styles['user-message']} style={messageStyle} {...props}>
        <CustomMarkdown content={message.content} />
      </div>
      <div className={styles['message-metadata']}>
        Tú • Ahora
      </div>
    </div>
  );
};

export default UserMessage;
